<h2 mat-dialog-title>{{ "demo.dialog.title" | translate }}</h2>

<mat-dialog-content>
  @if (selectedCategory) {
    <div class="flex option-wrapper">
      @if (selectedCategory.icon) {
        <app-icon [name]="selectedCategory.icon" />
      }
      <div>
        <h3>
          {{ selectedCategory.headline | translate }}

          @if (hasSecondLevelSelection && selectedOption) {
            | {{ selectedOption.headline | translate }}
          }
        </h3>
        <p>{{ selectedCategory.description | translate }}</p>
      </div>
    </div>
  }

  @if (step === DemoStep.PROCESSING_INITIAL) {
    <div class="content-wrapper intro-story">
      <h3>{{ "demo.dialog.steps.loadingInitial.headline" | translate }}</h3>
      <p>{{ "demo.dialog.steps.loadingInitial.body" | translate }}</p>
      <p class="bold">
        {{ "demo.dialog.steps.loadingInitial.closing" | translate }}
      </p>
    </div>
    <div class="content-wrapper">
      <app-scenario-animation
        class="scenario-animation"
        useCase="illu_rain_collect"
      />

      <app-processing-visual
        [percent]="processingProgressPercent"
        [elapsedDisplay]="processingElapsedDisplay"
        [durationDisplay]="processingDurationDisplay"
      />
    </div>
  }

  @if (step === DemoStep.SELECTION) {
    <p>{{ "demo.dialog.steps.userSelection" | translate }}</p>

    <div class="content-wrapper flex column gap-2">
      @for (option of options; track option.headline) {
        <app-card class="button card-button" (click)="onSelectOption(option)">
          @if (option.icon) {
            <app-icon [name]="option.icon" />
          }
          <div>
            <h3>{{ option.headline | translate }}</h3>
            <p>{{ option.description | translate }}</p>
          </div>
        </app-card>
      }
    </div>
  }

  @if (step === DemoStep.OPTION_SELECTION) {
    <p>{{ "demo.dialog.steps.optionSelection" | translate }}</p>
    <div class="content-wrapper flex column gap-2">
      @for (option of selectedCategory?.options ?? []; track option.headline) {
        <app-card
          class="button card-button"
          (click)="onSelectSubOption(option)"
        >
          <div>
            <h3>{{ option.headline | translate }}</h3>
            <p>{{ option.description | translate }}</p>
          </div>
        </app-card>
      }
      <app-card
        style="--spacing: 1rem"
        class="button card-button"
        (click)="onBack()"
      >
        <app-icon name="ic_chevron_left" />
        <p>{{ "demo.dialog.back" | translate }}</p>
      </app-card>
    </div>
  }

  @if (step === DemoStep.PROCESSING_FINAL) {
    <div class="content-wrapper">
      @if (selectedCategory?.useCase; as useCase) {
        <app-scenario-animation
          class="scenario-animation"
          [useCase]="useCase"
        />
      }
      <app-processing-visual
        [percent]="processingProgressPercent"
        [elapsedDisplay]="processingElapsedDisplay"
        [durationDisplay]="processingDurationDisplay"
      />
    </div>
  }

  @if (step === DemoStep.SUGGESTION && nextSuggestion; as suggestion) {
    <div class="suggestion-wrapper flex column center">
      @if (suggestion.option.icon) {
        <app-icon [name]="suggestion.option.icon" />
      }
      <h2>{{ "demo.dialog.steps.nextSuggestion.headline" | translate }}</h2>
      <p class="suggestion-message">{{ suggestion.messageKey | translate }}</p>
      <button
        type="button"
        class="button outlined-button mt-1"
        (click)="onSelectSuggestedNext(suggestion.option)"
      >
        {{ "demo.dialog.steps.nextSuggestion.start" | translate }}
      </button>
    </div>
  }

  @if (step === DemoStep.SUCCESS) {
    <div class="content-wrapper success-wrapper flex column center">
      <app-icon name="ic_check" />
      <h2>{{ "demo.dialog.steps.success" | translate }}</h2>
      @if (selectedCategory; as category) {
        @if (hasSecondLevelSelection) {
          @if (category.success; as categorySuccess) {
            <p>{{ categorySuccess | translate }}</p>
          }
          @if (selectedOption?.success; as optionSuccess) {
            <p>{{ optionSuccess | translate }}</p>
          }
        } @else {
          @if (selectedOption?.success ?? category.success; as success) {
            <p>{{ success | translate }}</p>
          }
        }
      }
      <p class="success-benefits">
        {{ "demo.dialog.steps.successBenefits" | translate }}
      </p>
      <div class="button-wrapper mt-1">
        <button
          type="button"
          class="button outlined-button"
          (click)="onLogout()"
        >
          {{ "demo.logoutButton" | translate }}
        </button>
        <button type="button" class="button primary-button" (click)="onClose()">
          {{ "demo.dialog.steps.newScenario" | translate }}
        </button>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (step === DemoStep.SUCCESS) {
    <p class="auto-return-hint">
      {{
        "demo.dialog.autoReturnHint"
          | translate: { seconds: successAutoCloseRemainingSeconds }
      }}
    </p>
  }

  @if (step !== DemoStep.SUCCESS && step !== DemoStep.SUGGESTION) {
    <button type="button" class="button outlined-button" (click)="onClose()">
      {{ "demo.dialog.closeConfirm.confirm" | translate }}
    </button>
  }

  @if (step === DemoStep.SUGGESTION && nextSuggestion) {
    <button
      type="button"
      class="button outlined-button"
      (click)="onSkipSuggestion()"
    >
      {{ "demo.dialog.steps.nextSuggestion.skip" | translate }}
    </button>
  }
</mat-dialog-actions>
